import React from 'react';

const Footer = ({ onGetStarted }) => {
  return (
    <footer className="site-footer">
      <div className="container">
        <a 
          href="https://www.lavation.com" 
          target="_blank" 
          rel="noopener noreferrer"
          className="footer-link"
        >
          <div className="footer-content">
            <span className="footer-text">a</span>
            <img src="/logosm.png" alt="Lavation Company" className="footer-logo" />
            <span className="footer-text">company</span>
          </div>
        </a>
        
        <div className="footer-nav-links">
          <a href="/about" className="footer-nav-link">About Us</a>
          <span className="footer-separator">•</span>
          <a href="/funeral-directors" className="footer-nav-link">Funeral Professionals</a>
          <span className="footer-separator">•</span>
          <button onClick={(e) => { e.preventDefault(); if (onGetStarted) onGetStarted(); }} className="footer-nav-link" style={{ border: 'none', background: 'none', color: 'inherit', textDecoration: 'none', padding: 0 }}>Get Started</button>
          <span className="footer-separator">•</span>
          <a href="/redeem" className="footer-nav-link">Redeem Code</a>
          <span className="footer-separator">•</span>
          <a href="/blog" className="footer-nav-link">Blog</a>
          <span className="footer-separator">•</span>
          <a href="/funeral-directors#fd-faq" className="footer-nav-link">FAQ</a>
          <span className="footer-separator">•</span>
          <a href="/help" className="footer-nav-link">Help</a>
          <span className="footer-separator">•</span>
          <a href="/terms" className="footer-nav-link">Terms of Service</a>
          <span className="footer-separator">•</span>
          <a href="/privacy" className="footer-nav-link">Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
